module.exports = __webpack_public_path__ + "static/media/herbs.94652667.png";